module.exports = __webpack_public_path__ + "static/assets/642fb2f987bf8b54f176af13746c04cb.png";